import React, {Component} from "react";
import {
  Alert
}                         from "react-bootstrap";
import { EVOUCHER }       from "actions/const";

import { IS_VALID }       from "utils";

import Create             from "./Create";
import View               from "./View";

export default class FormContainer extends Component {
  render () {
    let {
      EVoucher,

      formType,
      selectedData
    } = this.props;

    switch (formType.toUpperCase()) {
      case "CREATE":
      case "DUPLICATE":
        return <Create {...this.props}/>
        break;
      case "UPDATE": {
        if (EVoucher.isStatusExpired) {
          return (
            <Alert bsStyle='warning'>Updating of expired EVoucher is disabled.</Alert>
          );
        }

        return <Create {...this.props}/>
      }
        break;
      case "VIEW":
        return <View {...this.props}/>
        break;
      case "DELETE":
        return (
          <p>
            Are you sure you want to delete&nbsp;
            {IS_VALID(selectedData) && IS_VALID(selectedData.get("title")) ? (
              <span style={{ color: "red" }}>{selectedData.get("title")}</span>
            ) : (
              "this data"
            )}
            ?
          </p>
        );
      case "SUSPEND":
        return (
          <p>
            Are you sure you want to suspend&nbsp;
            {IS_VALID(selectedData) && IS_VALID(selectedData.get("title")) ? (
              <span style={{ color: "red" }}>{selectedData.get("title")}</span>
            ) : (
              "this data"
            )}
            ?
          </p>
        );
      case "UNSUSPEND":
        return (
          <p>
            Are you sure you want to unsuspend&nbsp;
            {IS_VALID(selectedData) && IS_VALID(selectedData.get("title")) ? (
              <span style={{ color: "red" }}>{selectedData.get("title")}</span>
            ) : (
              "this data"
            )}
            ?
          </p>
        );
      default:
        return "";
    }
  }

  componentWillUnmount () {
    let {
      EVoucher,
      actions
    } = this.props;

    let {
      genderOptions
    } = EVoucher;

    actions.setValue(
      EVOUCHER,
      {
        selectedData: null,
        formType: "",
        formId: "",

        typeK: null,
        transactionType: [],
        cardType: [],
        pointType: null,
        deductPointType: null,
        birthMonth: null,
        tdd_birthMonthStartDate: "",
        tdd_birthMonthEndDate: "",
        campaignStartDate: "",
        campaignEndDate: "",
        requiredEarningAmount: "",
        deductPointAmount: "",
        maxVoucherQuantity: "",
        maxVoucherQuantityPerDay: "",
        maxVoucherQuantityPerUser: "",
        maxVoucherQuantityPerUserPerDay: "",
        welcomeDays: "",
        version: null,
        campaignCategory: null,
        title: "",
        promotionName: "",
        descriptions: "",
        whereToRedeem: "",
        evScannerUser: [],
        manualDispense: "",
        serialNumberPrefix: "",
        amount: "",
        promoOwnerCostCenter: "",
        promoCategory: null,
        nnsl_amount: "",
        nnc_amount: "",
        image: null,
        isShowForFirstTimeUsers: false,
        isShowRemainingQuantity: false,
        isRateRequired: false,
        isShowMerchantsOwnRedemptionOnly: false,

        sendPushNotification: [],
        earningPeriod: null,
        earningPeriodStartDate: "",
        earningPeriodEndDate: "",

        voucherValidityType: null,
        voucherValidityDays: "",
        voucherValidityHour: "",
        voucherValidityMinute: "",
        voucherValiditySecond: "",
        voucherValidityStartDate: "",
        voucherValidityEndDate: "",
        voucherValidityStartTime: "",
        voucherValidityEndTime: "",
        voucherValidityIsUseCalendarDay: false,

        rateTimeConfigHour: "",
        rateTimeConfigMinute: "",
        rateTimeConfigSecond: "",

        specificUser: [],
        blacklistedUser: [],

        gender: genderOptions[0]
      }
    );
  }
}



// WEBPACK FOOTER //
// ./components/EVoucher/FormContainer/index.js